import Menu from "../../../components/Menu"

import styles from "./Sklad.module.sass"


const App = ({ className }) => {



  return (
    <div className={styles.overlay}>
      <Menu typ="sklad" />
    </div>
  );
};
export default App;
